"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Factory = Factory;
function Factory(type) {
    var c = function c(payload, meta) {
        return meta === undefined ? { type: type, payload: payload } : { type: type, payload: payload, meta: meta };
    };
    var e = function e(error, meta) {
        return meta === undefined ? { type: type, payload: error, error: true } : { type: type, payload: error, error: true, meta: meta };
    };
    c.type = type;
    c.error = e;
    return c;
}
//# sourceMappingURL=Factory.js.map


// WEBPACK FOOTER //
// ./node_modules/@zaibot/fsa/es5/Factory.js